import React, { useState, useMemo, useEffect, useCallback, useRef } from "react";
import { ThemeProvider as MuiThemeProvider, createTheme as createMuiTheme } from '@mui/material/styles';
import { ThemeProvider as CoreThemeProvider, createTheme as createCoreTheme } from '@material-ui/core/styles';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import globalConfig from '../../../../../configs/globalConfigs';
import AppBar from '@mui/material/AppBar';
import SwipeableViews from 'react-swipeable-views';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import { Stomp } from '@stomp/stompjs';

import Close from '@material-ui/icons/Close'
import { Snackbar } from '@material-ui/core';
import { Menu } from '@mui/material';

import Cookies from 'js-cookie';
import { MenuItem, Select, InputLabel, FormControl, IconButton } from '@mui/material';
import {
    FormLabel,
    RadioGroup,
    Radio,
} from '@material-ui/core';

import { useHistory } from "react-router-dom";
import moment from 'moment';
import { Drawer, List, ListItem, ListItemText, ListItemIcon, Box } from '@mui/material';
import DashboardIcon from '@mui/icons-material/Dashboard';

import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Collapse from '@material-ui/core/Collapse';
import Paper from '@mui/material/Paper';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Skeleton from '@material-ui/lab/Skeleton';
import {
    MapContainer,
    TileLayer,
    Marker,
    Popup,
    Polyline,
    Polygon,
    useMap,
    useMapEvents,
    Tooltip as LeafletTooltip
} from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

// MaterialReactTable removido conforme solicitacao de modernizacao do menu de gestao
import SecurityIcon from '@mui/icons-material/Security';
import SensorsIcon from '@mui/icons-material/Sensors';
import SignalCellularConnectedNoInternet4BarIcon from '@mui/icons-material/SignalCellularConnectedNoInternet4Bar';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import CallIcon from '@mui/icons-material/Call';
import PhoneInTalkIcon from '@mui/icons-material/PhoneInTalk';
import SyncIcon from '@mui/icons-material/Sync';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import InputAdornment from '@mui/material/InputAdornment';
import Tooltip from '@mui/material/Tooltip';
import Chip from '@mui/material/Chip';
import Divider from '@mui/material/Divider';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import PainelInstalacaoDetalhes from '../components/PainelInstalacaoDetalhes/index';
import GraficoDisponibilidade from '../../../../../components/GraficoDisponibilidade/GraficoDisponibilidade';

import BuildIcon from '@mui/icons-material/Build';
import Switch from '@mui/material/Switch';
import SettingsIcon from '@mui/icons-material/Settings';
import PowerIcon from '@mui/icons-material/Power';
import PowerOffIcon from '@mui/icons-material/Power';



import api from '../../../../../services/api';


import NavegadorGestao from "../../../../../components/NavBarGestao";
import "./MapPage.css";

import switch_off from '../../../../../assets/imgs/switch-off.png';
import switch_on from '../../../../../assets/imgs/switch-on.png';


import mini_icone_carro from '../../../../../assets/imgs/mini_icone_carro.png';

import mini_icone_moto from '../../../../../assets/imgs/mini_icone_moto.png';

import icone_origem from '../../../../../assets/imgs/icone_origem.png';
import icone_destino from '../../../../../assets/imgs/icone_destino.png';
import icone_parada from '../../../../../assets/imgs/icone_parada.png';


import icone_pgm from '../../../../../assets/imgs/icone_pgm.png';
import icone_modulo_sonoro from '../../../../../assets/imgs/icone_modulo_sonoro.png';

import icone_medidor from '../../../../../assets/imgs/icone_medidor.png';

import icone_subestacao from '../../../../../assets/imgs/icone_subestacao.png';
import icone_casa from '../../../../../assets/imgs/icone_casa.png';
import icone_loja from '../../../../../assets/imgs/icone_loja.png';


import alarmeAudio from '../../../../../assets/mp3/alarme.mp3';


const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        height: '1000px',

        backgroundColor: 'white',
    },
    toolbar: {

    },
    toolbarIcon: {

    },
    appBar: {

    },
    appBarShift: {

    },
    menuButton: {

    },
    menuButtonHidden: {

    },
    title: {
        flexGrow: 1,
    },
    drawerPaper: {

    },
    drawerPaperClose: {

    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        display: 'flex',


    },
    container: {
        display: 'flex',
        height: '1000px',

        backgroundColor: 'green',


    },
    paper: {

    },
    fixedHeight: {

    },
}));


const libraries = ["places"];


// Gerenciador de Áudio (Singleton)
const audioManager = {
    audio: new Audio(alarmeAudio),
    isPlaying: false,
    play() {
        if (!this.isPlaying) {
            this.audio.loop = true;
            this.audio.volume = 1.0;
            this.audio
                .play()
                .then(() => {
                    this.isPlaying = true;
                })
                .catch(error => console.error("Erro ao reproduzir o áudio:", error));
        }
    },
    pause() {
        if (this.isPlaying) {
            this.audio.pause();
            this.audio.currentTime = 0;
            this.isPlaying = false;
        }
    }
};

const transparentDivIcon = new L.divIcon({ className: 'transparent-marker-icon', html: '' });

function processarIcone(tipo) {
    if (tipo === 0) {
        return icone_pgm;
    } else if (tipo === 10) {
        return icone_medidor;
    } else if (tipo === 30) {
        return icone_modulo_sonoro;
    }
    return icone_pgm;
}

// Componente auxiliar para inicialização (desativado de loops durante navegação)
function RecenterAutomatically() {
    return null;
}


// Calcula tamanho proporcional de icones e textos no mapa baseado no zoom
function getZoomScale(currentZoom = 15) {
    const z = Math.min(Math.max(currentZoom || 15, 8), 19);
    const factor = Math.min(Math.max(0.55 + (z - 10) * (0.50 / 8), 0.45), 1.25);

    return {
        instalacaoIconSize: Math.round(38 * factor),
        equipamentoIconSize: Math.round(44 * factor),
        fontSize: Math.max(9, Math.round(11 * factor)),
        containerSize: Math.round(55 * factor),
        factor
    };
}

function processarIconeInstalacao(tipo) {
    if (tipo === 0) {
        return icone_casa;
    } else if (tipo === 1) {
        return icone_loja;
    } else if (tipo == 2) {
        return icone_subestacao;
    }
}

const LocalComponent = React.memo(({ 
    id_instalacao, 
    lat, 
    lng, 
    onClick, 
    tipo_icone, 
    nome_mapa, 
    status, 
    status_geral,
    instalacao,
    darkMode,
    zoom,
    definingPerimeter,
    onDefinirPerimetro,
    onSalvarPerimetro
}) => {
    const scale = getZoomScale(zoom);
    const statusColor = status_geral === "PROTEGIDA" ? "#10b981" :
                        status_geral === "DESARMADA" ? "#f59e0b" :
                        status_geral === "DESCONECTADA" ? "#64748b" : 
                        status_geral === "ALARME" ? "#ef4444" : "#10b981";
    const [showMenu, setShowMenu] = useState(false);

    const handleContextMenu = (event) => {
        event.preventDefault();
        event.stopPropagation();
        setShowMenu(prev => !prev);
    };

    const handleClickGerenciar = () => {
        const url = `/gestao/administracao/clientes/gerenciarcliente/instalacao/gerenciarinstalacao/${id_instalacao}/0`;
        window.open(url, '_blank');
        setShowMenu(false);
    };

    const handleClickDefinirPerimetro = (event) => {
        event.stopPropagation();
        if (onDefinirPerimetro) onDefinirPerimetro(id_instalacao);
        setShowMenu(false);
    };

    const handleClickSalvarPerimetro = (event) => {
        event.stopPropagation();
        if (onSalvarPerimetro) onSalvarPerimetro(id_instalacao);
        setShowMenu(false);
    };

    return (
        <Marker position={[lat, lng]} icon={transparentDivIcon}>
            <LeafletTooltip
                permanent
                direction="center"
                className="transparent-tooltip"
            >
                <div
                    style={{
                        position: "relative",
                        transform: "translate(-50%, -50%)",
                        height: `${scale.containerSize}px`,
                        width: `${scale.containerSize}px`,
                        cursor: 'pointer'
                    }}
                    onClick={(event) => {
                        event.stopPropagation();
                        onClick(lat, lng);
                    }}
                >
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', margin: 0 }}>
                        <img
                            alt={"icone"}
                            style={{
                                textAlign: 'center',
                                width: `${scale.instalacaoIconSize}px`,
                                height: `${scale.instalacaoIconSize}px`,
                                transition: 'width 0.2s, height 0.2s',
                                filter: `drop-shadow(0 2px 4px ${statusColor}90)`
                            }}
                            src={processarIconeInstalacao(tipo_icone)}
                            onContextMenu={handleContextMenu}
                        />
                        <span style={{
                            color: statusColor,
                            fontSize: `${scale.fontSize}px`,
                            fontWeight: 'bold',
                            whiteSpace: 'nowrap',
                            padding: '1px 5px',
                            borderRadius: '4px',
                            backgroundColor: darkMode ? 'rgba(15, 23, 42, 0.88)' : 'rgba(255, 255, 255, 0.92)',
                            border: `1.5px solid ${statusColor}`,
                            boxShadow: darkMode ? '0 2px 6px rgba(0,0,0,0.6)' : '0 2px 4px rgba(0,0,0,0.2)',
                            marginTop: '2px',
                            transition: 'font-size 0.2s'
                        }}>
                            {nome_mapa}
                        </span>
                    </div>
                    {showMenu && (
                        <div style={{
                            position: 'absolute',
                            backgroundColor: darkMode ? '#1e293b' : 'white',
                            border: darkMode ? '1px solid #334155' : '1px solid black',
                            color: darkMode ? '#f8fafc' : 'black',
                            borderRadius: '6px',
                            padding: '10px',
                            top: '50px',
                            left: '50%',
                            transform: 'translateX(-50%)',
                            zIndex: 1000,
                            boxShadow: darkMode ? '0 4px 16px rgba(0,0,0,0.6)' : '0 2px 6px rgba(0,0,0,0.3)',
                        }}>
                            <IconButton color="error" onClick={handleClickGerenciar}>
                                <SettingsIcon />
                                <span style={{ marginLeft: '8px', color: darkMode ? '#f8fafc' : 'inherit' }}>Gerenciar</span>
                            </IconButton>

                            {!definingPerimeter && (
                                <IconButton color="error" onClick={handleClickDefinirPerimetro}>
                                    <SettingsIcon />
                                    <span style={{ marginLeft: '8px', color: darkMode ? '#f8fafc' : 'inherit' }}>Definir Perímetro</span>
                                </IconButton>
                            )}

                            {definingPerimeter && (
                                <IconButton color="error" onClick={handleClickSalvarPerimetro}>
                                    <SettingsIcon />
                                    <span style={{ marginLeft: '8px', color: darkMode ? '#f8fafc' : 'inherit' }}>Salvar Perímetro</span>
                                </IconButton>
                            )}
                        </div>
                    )}
                </div>
            </LeafletTooltip>
        </Marker>
    );
});

const ModuloPGMComponent = React.memo(({ 
    lat, 
    lng, 
    tipo, 
    onClick, 
    status, 
    equipamento, 
    perimetro, 
    id_instalacao,
    darkMode,
    zoom,
    idLocalDefinindoPerimetro,
    onSendPgmCommand
}) => {
    const [isHovered, setIsHovered] = React.useState(false);
    const [showMenu, setShowMenu] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [anchorElReles, setAnchorElReles] = useState(null);
    const [anchorElAudios, setAnchorElAudios] = useState(null);
    const [subMenuOpen, setSubMenuOpen] = useState(false);
    const [subMenuOpenReles, setSubMenuOpenReles] = useState(false);
    const [subMenuOpenAudios, setSubMenuOpenAudios] = useState(false);

    const handleMenuOpen = useCallback((event) => {
        event.preventDefault();
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
        setSubMenuOpen(true);
    }, []);

    const handleMenuOpenReles = (event) => {
        event.preventDefault();
        event.stopPropagation();
        setAnchorElReles(event.currentTarget);
        setSubMenuOpenReles(true);
    };

    const handleMenuOpenAudios = (event) => {
        event.preventDefault();
        event.stopPropagation();
        setAnchorElAudios(event.currentTarget);
        setSubMenuOpenAudios(true);
    };

    const handleMenuClose = (event) => {
        event.preventDefault();
        event.stopPropagation();
        setAnchorEl(null);
        setSubMenuOpen(false);
    };

    const handleMenuCloseReles = (event) => {
        event.preventDefault();
        event.stopPropagation();
        setAnchorElReles(null);
        setSubMenuOpenReles(false);
    };

    const handleMenuCloseAudios = (event) => {
        event.preventDefault();
        event.stopPropagation();
        setAnchorElAudios(null);
        setSubMenuOpenAudios(false);
    };

    const handleContextMenu = (event) => {
        event.preventDefault();
        event.stopPropagation();
        setShowMenu(prev => !prev);
    };

    const localPerimeterPoints = useMemo(() => {
        return perimetro
            ? Array.from({ length: 8 }, (_, i) => {
                  const lat = parseFloat(perimetro[`latitude${i + 1}`]);
                  const lng = parseFloat(perimetro[`longitude${i + 1}`]);
                  return !isNaN(lat) && !isNaN(lng) ? { lat, lng } : null;
              }).filter(point => point !== null)
            : [];
    }, [perimetro]);

    // Calcular a diferença de tempo
    const now = new Date();
    const lastResponse = new Date(equipamento?.modulo_pgm?.data_hora_ultima_resposta);
    const differenceInMinutes = (now - lastResponse) / 1000 / 60;

    const alarme = equipamento?.alarme;

    let statusText;
    let statusColor;
    let isBlinking = false;

    const scale = getZoomScale(zoom);
    const armada = equipamento?.modulo_pgm?.armada;

    if (alarme) {
        statusText = "ALARME";
        statusColor = "red";
        isBlinking = false; // Alarme fica vermelho fixo, NÃO pisca
    } else if (differenceInMinutes < 3) {
        if (armada) {
            statusText = "ONLINE - ARMADA";
            statusColor = "green";
        } else {
            statusText = "ONLINE - DESARMADA";
            statusColor = "yellow";
        }
        isBlinking = false;
    } else {
        statusText = "OFFLINE";
        statusColor = "red";
        isBlinking = true; // APENAS a palavra OFFLINE pisca
    }

    // Controlar reprodução de áudio
    useEffect(() => {
        if (alarme) {
            audioManager.play();
        } else {
            audioManager.pause();
        }
    }, [alarme]);

    const [mostrarRele, setMostrarRele] = useState(false);

    useEffect(() => {
        let timeoutId;
        if (!isHovered) {
            timeoutId = setTimeout(() => {
                setMostrarRele(false);
            }, 5000);
        } else {
            setMostrarRele(true);
            clearTimeout(timeoutId);
        }
        return () => clearTimeout(timeoutId);
    }, [isHovered]);

    const handlePgmClick = (comando) => {
        if (onSendPgmCommand && equipamento?.modulo_pgm?.id_modulo_pgm) {
            onSendPgmCommand(equipamento.modulo_pgm.id_modulo_pgm, comando);
        }
        setAnchorElAudios(null);
        setSubMenuOpenAudios(false);
        setAnchorElReles(null);
        setSubMenuOpenReles(false);
        setAnchorEl(null);
        setSubMenuOpen(false);
    };

    const processarIndexAtivarRele = (index) => {
        if (index === 1) return 1;
        if (index === 2) return 2;
        if (index === 3) return -1;
        if (index === 4) return -2;
    };

    const processarIndexDesativarRele = (index) => {
        if (index === 1) return 0;
        if (index === 2) return 3;
        if (index === 3) return 4;
        if (index === 4) return -2;
    };

    if (zoom < 16) return null;

    return (
        <React.Fragment>
            <Marker position={[lat, lng]} icon={transparentDivIcon}>
                <LeafletTooltip permanent direction="center" className="transparent-tooltip">
                    <div>
                        {(alarme || differenceInMinutes > 3 || zoom > 15) && (
                            <div
                                style={{
                                    position: "relative",
                                    transform: "translate(-50%, -50%)",
                                    height: "100px",
                                    width: "100px",
                                    borderRadius: "50%",
                                }}
                                onClick={(event) => {
                                    event.stopPropagation();
                                    onClick(lat, lng);
                                }}
                            >
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', margin: 0 }}>
                                    <img
                                        alt={"icone"}
                                        style={{
                                            textAlign: 'center',
                                            width: `${scale.equipamentoIconSize}px`,
                                            height: `${scale.equipamentoIconSize}px`,
                                            transition: 'width 0.2s, height 0.2s'
                                        }}
                                        src={processarIcone(tipo)}
                                        onContextMenu={handleContextMenu}
                                    />
                                </div>
                                {showMenu && (
                                    <div style={{
                                        position: 'absolute',
                                        backgroundColor: darkMode ? '#1e293b' : 'white',
                                        border: darkMode ? '1px solid #334155' : '1px solid black',
                                        color: darkMode ? '#f8fafc' : 'black',
                                        borderRadius: '6px',
                                        padding: '10px',
                                        top: '50px',
                                        left: '50%',
                                        transform: 'translateX(-50%)',
                                        zIndex: 1000,
                                        boxShadow: darkMode ? '0 4px 16px rgba(0,0,0,0.6)' : '0 2px 6px rgba(0,0,0,0.3)',
                                    }}>
                                        <IconButton color="error" onClick={handleMenuOpen}>
                                            <SettingsIcon />
                                            <span style={{ marginLeft: '8px', color: darkMode ? '#f8fafc' : 'inherit' }}>PGM</span>
                                        </IconButton>
                                        <Menu
                                            anchorEl={anchorEl}
                                            open={subMenuOpen}
                                            onClose={handleMenuClose}
                                            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                                            transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                                            PaperProps={{
                                                style: {
                                                    border: darkMode ? '1px solid #334155' : '1px solid black',
                                                    borderRadius: '4px',
                                                    padding: '10px',
                                                    zIndex: 555,
                                                    backgroundColor: darkMode ? '#1e293b' : 'white',
                                                    color: darkMode ? '#f8fafc' : 'inherit',
                                                    boxShadow: darkMode ? '0 4px 16px rgba(0,0,0,0.6)' : '0 2px 6px rgba(0,0,0,0.3)',
                                                }
                                            }}
                                        >
                                            <MenuItem sx={{ color: darkMode ? '#f8fafc' : 'inherit' }} onClick={(e) => { handleMenuOpenReles(e); }}>Reles</MenuItem>
                                            <MenuItem sx={{ color: darkMode ? '#f8fafc' : 'inherit' }} onClick={(e) => { handleMenuOpenAudios(e); }}>Audio</MenuItem>
                                        </Menu>

                                        <Menu
                                            anchorEl={anchorElReles}
                                            open={subMenuOpenReles}
                                            onClose={handleMenuCloseReles}
                                            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                                            transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                                            PaperProps={{
                                                style: {
                                                    border: darkMode ? '1px solid #334155' : '1px solid black',
                                                    borderRadius: '4px',
                                                    padding: '10px',
                                                    zIndex: 555,
                                                    backgroundColor: darkMode ? '#1e293b' : 'white',
                                                    color: darkMode ? '#f8fafc' : 'inherit',
                                                    boxShadow: darkMode ? '0 4px 16px rgba(0,0,0,0.6)' : '0 2px 6px rgba(0,0,0,0.3)',
                                                }
                                            }}
                                        >
                                            {[1, 2, 3, 4].map((index) => {
                                                const releNome = equipamento?.modulo_pgm[`nome_rele${index}`];
                                                const status = equipamento?.modulo_pgm[`status_rele${index}`];

                                                return (
                                                    <MenuItem key={index} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', color: darkMode ? '#f8fafc' : 'inherit' }}>
                                                        <span>{releNome}</span>

                                                        {status === "on" ? (
                                                            <IconButton color="error" onClick={() => { handlePgmClick(processarIndexDesativarRele(index)) }}>
                                                                <PowerOffIcon />
                                                                <span style={{ marginLeft: '4px', fontSize: '13px' }}>Desativar</span>
                                                            </IconButton>
                                                        ) : (
                                                            <IconButton color="primary" onClick={() => { handlePgmClick(processarIndexAtivarRele(index)) }}>
                                                                <PowerIcon />
                                                                <span style={{ marginLeft: '4px', fontSize: '13px' }}>Ativar</span>
                                                            </IconButton>
                                                        )}
                                                    </MenuItem>
                                                );
                                            })}
                                        </Menu>

                                        <Menu
                                            anchorEl={anchorElAudios}
                                            open={subMenuOpenAudios}
                                            onClose={handleMenuCloseAudios}
                                            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                                            transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                                            PaperProps={{
                                                style: {
                                                    border: darkMode ? '1px solid #334155' : '1px solid black',
                                                    borderRadius: '4px',
                                                    padding: '10px',
                                                    zIndex: 555,
                                                    backgroundColor: darkMode ? '#1e293b' : 'white',
                                                    color: darkMode ? '#f8fafc' : 'inherit',
                                                    boxShadow: darkMode ? '0 4px 16px rgba(0,0,0,0.6)' : '0 2px 6px rgba(0,0,0,0.3)',
                                                }
                                            }}
                                        >
                                        </Menu>
                                    </div>
                                )}

                                {equipamento.modulo_pgm && (
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '4px' }}>
                                        <span style={{
                                            color: statusColor,
                                            fontSize: `${scale.fontSize}px`,
                                            fontWeight: 800,
                                            backgroundColor: darkMode ? 'rgba(15, 23, 42, 0.88)' : 'rgba(255, 255, 255, 0.92)',
                                            padding: '2px 6px',
                                            borderRadius: '4px',
                                            border: `1.5px solid ${statusColor}`,
                                            boxShadow: darkMode ? '0 2px 6px rgba(0,0,0,0.6)' : '0 2px 4px rgba(0,0,0,0.2)',
                                            whiteSpace: 'nowrap'
                                        }}>
                                            {equipamento.modulo_pgm.codigo + (equipamento.nome_mapa ? " - " + equipamento.nome_mapa : "")}
                                        </span>
                                        <span style={{
                                            color: statusColor,
                                            fontSize: '11px',
                                            fontWeight: 800,
                                            marginTop: '2px',
                                            textShadow: '1px 1px 2px rgba(0,0,0,0.8)',
                                            animation: isBlinking ? 'blink 2s step-start infinite' : 'none'
                                        }}>
                                            {statusText}
                                        </span>
                                    </div>
                                )}

                                {zoom > 15 && mostrarRele && (
                                    <div style={{
                                        color: darkMode ? '#f8fafc' : 'black', fontSize: '14px', fontWeight: 'bold',
                                        display: 'flex', alignItems: 'center', gap: '8px', marginTop: '10px'
                                    }}>
                                        {[1, 2, 3, 4].map((index) => {
                                            const releNome = equipamento?.modulo_pgm[`nome_rele${index}`];
                                            const status = equipamento?.modulo_pgm[`status_rele${index}`];
                                            const iconPath = status === "on" ? switch_on : switch_off;

                                            return (
                                                <div key={index} style={{
                                                    border: darkMode ? '1px solid #334155' : '1px solid black',
                                                    borderRadius: '4px', padding: '5px', display: 'flex', alignItems: 'center', 
                                                    backgroundColor: darkMode ? '#1e293b' : 'white',
                                                    color: darkMode ? '#f8fafc' : 'black'
                                                }}>
                                                    <span>{releNome}</span>
                                                    {status === "on" ? (
                                                        <IconButton color="error" onClick={() => { handlePgmClick(processarIndexDesativarRele(index)) }}>
                                                            <img src={iconPath} alt={`${status} icon`} style={{ width: '40px', height: '40px', marginLeft: '4px' }} />
                                                        </IconButton>
                                                    ) : (
                                                        <IconButton color="primary" onClick={() => { handlePgmClick(processarIndexAtivarRele(index)) }}>
                                                            <img src={iconPath} alt={`${status} icon`} style={{ width: '40px', height: '40px', marginLeft: '4px' }} />
                                                        </IconButton>
                                                    )}
                                                </div>
                                            );
                                        })}
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </LeafletTooltip>
            </Marker>

            {zoom > 15 && (
                localPerimeterPoints.length >= 2 && idLocalDefinindoPerimetro !== id_instalacao) && (
                    localPerimeterPoints.length === 2 ? (
                        <Polyline
                            positions={localPerimeterPoints}
                            pathOptions={{ color: statusColor, opacity: 1.0, weight: 2 }}
                        />
                    ) : (
                        <Polygon
                            positions={localPerimeterPoints}
                            pathOptions={{
                                fillColor: statusColor,
                                fillOpacity: 0.35,
                                color: statusColor,
                                opacity: 0.8,
                                weight: 2
                            }}
                        />
                    )
                )}
        </React.Fragment>
    );
});


// Componente de Mapa para Modulos Unifier (tipo 30)
const ModuloUnifierComponent = React.memo(({
    lat,
    lng,
    tipo,
    onClick,
    status,
    equipamento,
    id_instalacao,
    darkMode,
    zoom,
    onSipCall
}) => {
    const [showMenu, setShowMenu] = useState(false);

    const now = new Date();
    const lastResponse = new Date(equipamento?.modulo_sonoro?.data_hora_ultima_resposta);
    const differenceInMinutes = (now - lastResponse) / 1000 / 60;
    const alarme = equipamento?.alarme;
    const armada = equipamento?.modulo_sonoro?.armada;

    const scale = getZoomScale(zoom);
    let statusText = "ONLINE";
    let statusColor = "#10b981";
    let isBlinking = false;

    if (alarme) {
        statusText = "ALARME";
        statusColor = "#ef4444";
        isBlinking = false;
    } else if (differenceInMinutes < 3) {
        if (armada) {
            statusText = "ONLINE - ARMADA";
            statusColor = "#10b981";
        } else {
            statusText = "ONLINE - DESARMADA";
            statusColor = "#f59e0b";
        }
        isBlinking = false;
    } else {
        statusText = "OFFLINE";
        statusColor = "#ef4444";
        isBlinking = true;
    }

    const handleContextMenu = (event) => {
        event.preventDefault();
        event.stopPropagation();
        setShowMenu(prev => !prev);
    };

    const codigoUnifier = equipamento?.modulo_sonoro?.codigo || equipamento?.identificador_integrador || "";
    const ramalUnifier = equipamento?.modulo_sonoro?.ramal || equipamento?.ramal;

    if (zoom < 16) return null;

    return (
        <Marker position={[lat, lng]} icon={transparentDivIcon}>
            <LeafletTooltip permanent direction="center" className="transparent-tooltip">
                <div>
                    {(alarme || differenceInMinutes > 3 || zoom > 14) && (
                        <div
                            style={{
                                position: "relative",
                                transform: "translate(-50%, -50%)",
                                height: "100px",
                                width: "100px",
                                cursor: "pointer"
                            }}
                            onClick={(event) => {
                                event.stopPropagation();
                                if (onClick) onClick(lat, lng);
                            }}
                        >
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', margin: 0 }}>
                                <img
                                    alt={"icone-unifier"}
                                    style={{
                                        textAlign: 'center',
                                        width: `${scale.equipamentoIconSize}px`,
                                        height: `${scale.equipamentoIconSize}px`,
                                        transition: 'width 0.2s, height 0.2s'
                                    }}
                                    src={icone_modulo_sonoro}
                                    onContextMenu={handleContextMenu}
                                />
                            </div>

                            {codigoUnifier && (
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '4px' }}>
                                    <span style={{
                                        color: statusColor,
                                        fontSize: `${scale.fontSize}px`,
                                        fontWeight: 800,
                                        backgroundColor: darkMode ? 'rgba(15, 23, 42, 0.88)' : 'rgba(255, 255, 255, 0.92)',
                                        padding: '2px 6px',
                                        borderRadius: '4px',
                                        border: `1.5px solid ${statusColor}`,
                                        boxShadow: darkMode ? '0 2px 6px rgba(0,0,0,0.6)' : '0 2px 4px rgba(0,0,0,0.2)',
                                        whiteSpace: 'nowrap'
                                    }}>
                                        {codigoUnifier + (equipamento.nome_mapa ? " - " + equipamento.nome_mapa : "")}
                                    </span>
                                    <span style={{
                                        color: statusColor,
                                        fontSize: '11px',
                                        fontWeight: 800,
                                        marginTop: '2px',
                                        textShadow: '1px 1px 2px rgba(0,0,0,0.8)',
                                        animation: isBlinking ? 'blink 2s step-start infinite' : 'none'
                                    }}>
                                        {statusText}
                                    </span>
                                </div>
                            )}

                            {showMenu && (
                                <div style={{
                                    position: 'absolute',
                                    backgroundColor: darkMode ? '#1e293b' : 'white',
                                    border: darkMode ? '1px solid #334155' : '1px solid black',
                                    color: darkMode ? '#f8fafc' : 'black',
                                    borderRadius: '6px',
                                    padding: '8px',
                                    top: '50px',
                                    left: '50%',
                                    transform: 'translateX(-50%)',
                                    zIndex: 1000,
                                    boxShadow: darkMode ? '0 4px 16px rgba(0,0,0,0.6)' : '0 2px 6px rgba(0,0,0,0.3)',
                                    whiteSpace: 'nowrap'
                                }}>
                                    {ramalUnifier && (
                                        <IconButton 
                                            color="success" 
                                            size="small" 
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                if (onSipCall) onSipCall(ramalUnifier, e);
                                                setShowMenu(false);
                                            }}
                                        >
                                            <CallIcon sx={{ fontSize: 16 }} />
                                            <span style={{ marginLeft: '6px', fontSize: '12px', fontWeight: 600 }}>
                                                Ligar ({ramalUnifier})
                                            </span>
                                        </IconButton>
                                    )}
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </LeafletTooltip>
        </Marker>
    );
});

export default function MonitoramentoMapa() {
    const audioRef = useRef(new Audio(alarmeAudio)); // Inicializar o ref com o áudio importado

    const [darkMode, setDarkMode] = useState(() => {
        const saved = Cookies.get('darkMode') || Cookies.get('tema');
        return saved === 'true' || saved === 'dark';
    });

    useEffect(() => {
        const updateTheme = () => {
            const saved = Cookies.get('darkMode') || Cookies.get('tema');
            const currentVal = saved === 'true' || saved === 'dark';
            setDarkMode(prev => prev !== currentVal ? currentVal : prev);
        };
        updateTheme();
        window.addEventListener('darkModeChanged', updateTheme);
        window.addEventListener('storage', updateTheme);
        const timer = setInterval(updateTheme, 3000);
        return () => {
            window.removeEventListener('darkModeChanged', updateTheme);
            window.removeEventListener('storage', updateTheme);
            clearInterval(timer);
        };
    }, []);

    const themeV4 = useMemo(() => createCoreTheme({
        palette: {
            type: darkMode ? 'dark' : 'light',
            background: {
                default: darkMode ? '#0b1120' : '#f1f5f9',
                paper: darkMode ? '#1e293b' : '#ffffff',
            },
            text: {
                primary: darkMode ? '#f8fafc' : '#0f172a',
                secondary: darkMode ? '#94a3b8' : '#64748b',
            }
        }
    }), [darkMode]);

    const themeV5 = useMemo(() => createMuiTheme({
        palette: {
            mode: darkMode ? 'dark' : 'light',
            background: {
                default: darkMode ? '#0b1120' : '#f1f5f9',
                paper: darkMode ? '#1e293b' : '#ffffff',
            },
            text: {
                primary: darkMode ? '#f8fafc' : '#0f172a',
                secondary: darkMode ? '#94a3b8' : '#64748b',
            }
        }
    }), [darkMode]);

    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState('success');

    const handleCloseSnackbar = () => {
        setSnackbarOpen(false);
    };

    const classes = useStyles();
    const history = useHistory();


    const [value, setValue] = React.useState(0);



    const [showTable, setShowTable] = useState(true);

    // Novos estados de controle do menu de gestao e recepcao
    const [searchTerm, setSearchTerm] = useState("");
    const [statusFiltros, setStatusFiltros] = useState({
        PROTEGIDA: true,
        DESARMADA: true,
        DESCONECTADA: true,
        ALARME: true
    });
    const [isProcessandoCiclo, setIsProcessandoCiclo] = useState(false);
    const [lastSyncTime, setLastSyncTime] = useState(null);
    const [instalacaoSelecionadaId, setInstalacaoSelecionadaId] = useState(null);
    const [instalacaoPainelDetalhes, setInstalacaoPainelDetalhes] = useState(null);
    const [openGraficoDisponibilidade, setOpenGraficoDisponibilidade] = useState(false);

    const handleSipHangup = useCallback(() => {
        window.postMessage({ type: 'HANGUP_CALL' }, '*');
    }, []);

    const returnDescricaoEndereco = useCallback((objeto) => {
        if (!objeto) return "";
        return `${objeto.logradouro || ''}, ${objeto.numero || ''}, ${objeto.bairro || ''} - ${objeto.cidade || ''}/${objeto.estado || ''}`;
    }, []);

    const formatarDataHora = useCallback((dataStr) => {
        if (!dataStr) return "Sem registro";
        const m = moment(dataStr);
        if (!m.isValid()) return String(dataStr);
        return m.format('DD/MM/YYYY HH:mm:ss');
    }, []);


    const toggleStatusFiltro = useCallback((statusKey) => {
        setStatusFiltros(prev => ({
            ...prev,
            [statusKey]: !prev[statusKey]
        }));
    }, []);

    const handleSipCall = useCallback((ramal, e) => {
        if (e && e.stopPropagation) e.stopPropagation();
        if (!ramal) return;
        window.postMessage({ type: 'CALL_NUMBER', number: ramal }, '*');
        window.dispatchEvent(new CustomEvent('open-sip-call', { 
            detail: { ramal, usuario: Cookies.get('usuario') } 
        }));
        setSnackbarMessage(`Iniciando chamada para ramal ${ramal}...`);
        setSnackbarSeverity('info');
        setSnackbarOpen(true);
    }, []);



    const [instalacoes, setInstalacoes] = useState([]);

    // Enriquecimento e calculo de status e contadores de instalacoes
    const { instalacoesEnriquecidas, snapshot } = useMemo(() => {
        if (!instalacoes || !Array.isArray(instalacoes)) {
            return {
                instalacoesEnriquecidas: [],
                snapshot: {
                    total_instalacoes: 0,
                    total_protegidas: 0,
                    total_desarmadas: 0,
                    total_desconectadas: 0,
                    total_em_alarme: 0
                }
            };
        }

        const now = Date.now();
        let prot = 0;
        let desar = 0;
        let desc = 0;
        let alar = 0;

        const processadas = instalacoes.map(inst => {
            let instAlarme = false;
            let instOnline = false;
            let instArmada = false;
            let codigoPgm = null;
            let dataHoraPgm = null;
            let codigoSonoro = null;
            let dataHoraSonoro = null;
            let temModuloSonoro = false;
            let ramalInstalacao = inst.ramal || null;

            const searchTokens = [
                String(inst.id_instalacao || ''),
                inst.nome_mapa || '',
                inst.identificador_integrador || '',
                inst.logradouro || '',
                inst.bairro || '',
                inst.cidade || ''
            ];

            if (inst.equipamentos && Array.isArray(inst.equipamentos)) {
                inst.equipamentos.forEach(eq => {
                    if (!eq) return;
                    const tipo = eq.tipo_equipamento_area_tecnica;
                    if (tipo === 0 && eq.modulo_pgm) {
                        const mod = eq.modulo_pgm;
                        if (mod.codigo) {
                            codigoPgm = mod.codigo;
                            searchTokens.push(String(mod.codigo));
                        }
                        if (mod.data_hora_ultima_resposta) {
                            dataHoraPgm = mod.data_hora_ultima_resposta;
                        }
                        if (!ramalInstalacao && mod.ramal) ramalInstalacao = mod.ramal;

                        const last = new Date(mod.data_hora_ultima_resposta);
                        const diffMin = (now - last) / 1000 / 60;
                        const eqAlarme = !!eq.alarme;
                        if (eqAlarme) instAlarme = true;
                        const eqOnline = eqAlarme || (diffMin < 3);
                        if (eqOnline) instOnline = true;

                        let countsAsArmed = !!mod.armada;
                        if (!mod.status_central && mod.status_zonas) {
                            countsAsArmed = (mod.status_zonas || "").split(";").some(l => {
                                const p = l.split(",");
                                if (p.length < 4) return false;
                                const s = (p[3] || "").toLowerCase().trim();
                                return s === "armada" || s === "true" || s === "1";
                            });
                        }
                        if (mod.status_central) {
                            const sc = mod.status_central.toLowerCase();
                            if (sc.includes("away") || sc.includes("stay")) {
                                countsAsArmed = true;
                            }
                        }
                        if (eqOnline && countsAsArmed) {
                            instArmada = true;
                        }
                    } else if (tipo === 30 && eq.modulo_sonoro) {
                        const mod = eq.modulo_sonoro;
                        temModuloSonoro = true;
                        if (mod.codigo) {
                            codigoSonoro = mod.codigo;
                            searchTokens.push(String(mod.codigo));
                        }
                        if (mod.data_hora_ultima_resposta) {
                            dataHoraSonoro = mod.data_hora_ultima_resposta;
                        }
                        if (!ramalInstalacao && mod.ramal) ramalInstalacao = mod.ramal;
                        const last = new Date(mod.data_hora_ultima_resposta);
                        const diffMin = (now - last) / 1000 / 60;
                        if (eq.alarme) instAlarme = true;
                        if (diffMin < 3) instOnline = true;
                    }
                    if (!ramalInstalacao && eq.ramal) {
                        ramalInstalacao = eq.ramal;
                    }
                });
            }

            if (ramalInstalacao) {
                searchTokens.push(String(ramalInstalacao));
            }

            let statusGeral = "DESARMADA";
            if (instAlarme) {
                statusGeral = "ALARME";
                alar++;
            } else if (!instOnline) {
                statusGeral = "DESCONECTADA";
                desc++;
            } else if (instArmada) {
                statusGeral = "PROTEGIDA";
                prot++;
            } else {
                statusGeral = "DESARMADA";
                desar++;
            }

            searchTokens.push(statusGeral);

            return {
                ...inst,
                status_geral: statusGeral,
                codigo_pgm: codigoPgm,
                data_hora_pgm: dataHoraPgm || inst.data_hora_ultima_resposta || null,
                codigo_sonoro: codigoSonoro,
                data_hora_sonoro: dataHoraSonoro,
                tem_modulo_sonoro: temModuloSonoro || Boolean(codigoSonoro || dataHoraSonoro),
                ramal: ramalInstalacao,
                search_index: searchTokens.join(' ').toLowerCase()
            };
        });

        return {
            instalacoesEnriquecidas: processadas,
            snapshot: {
                total_instalacoes: processadas.length,
                total_protegidas: prot,
                total_desarmadas: desar,
                total_desconectadas: desc,
                total_em_alarme: alar
            }
        };
    }, [instalacoes]);

    // Filtragem em tempo real para a listagem lateral
    const instalacoesFiltradas = useMemo(() => {
        if (!instalacoesEnriquecidas || !instalacoesEnriquecidas.length) return [];
        const term = searchTerm.trim().toLowerCase();

        return instalacoesEnriquecidas.filter(inst => {
            if (!statusFiltros[inst.status_geral]) {
                return false;
            }
            if (term) {
                if (!inst.search_index || !inst.search_index.includes(term)) {
                    return false;
                }
            }
            return true;
        });
    }, [instalacoesEnriquecidas, statusFiltros, searchTerm]);

    const [idLocalDefinindoPerimetro, setIdLocalDefinindoPerimetro] = useState(0); // Indica se está definindo perímetros
    const [definingPerimeter, setDefiningPerimeter] = useState(false); // Indica se está definindo perímetros
    const [perimeterPoints, setPerimeterPoints] = useState([]); // Armazena os pontos do perímetro
    const [currentPerimeter, setCurrentPerimeter] = useState(1); // Controla qual perímetro está sendo definido (P1 a P4)



    const handleMapClick = (event) => {
        if (definingPerimeter && currentPerimeter <= 8) {
            const newPoint = {
                lat: event.latLng.lat(),
                lng: event.latLng.lng(),
                label: `Perímetro ${currentPerimeter}`
            };
            setPerimeterPoints([...perimeterPoints, newPoint]); // Adiciona o novo ponto ao estado
            setCurrentPerimeter(currentPerimeter + 1); // Avança para o próximo perímetro


        } else {
            //  event.preventDefault(); // Impede o menu de contexto padrão do navegador
            // event.stopPropagation(); // Impede a propagação do evento para o mapa
        }
    };



    const handleMenuClick = (index) => {
        // Aqui você pode adicionar lógica para lidar com cliques em outros itens
        // Além de exibir a tabela ao clicar no ícone "Instalações"
        if (index === 0) {
            setShowTable(!showTable); // Alterna a visibilidade da tabela
        }
    };



    const [map, setMap] = useState();
    const mapRef = useRef(null);



    const [lat, setLat] = useState();
    const [lng, setLng] = useState();

    const [mapPosition, setMapPosition] = useState({ lat: lat, lng: lng });
    const [zoom, setZoom] = useState(5);

    const handleMarkerClick = useCallback((lat, lng) => {
        setZoom(18);
        setMapPosition({ lat, lng });
        if (mapRef.current) {
            try {
                mapRef.current.flyTo([lat, lng], 18, { animate: true, duration: 1.2 });
            } catch (e) {
                try { mapRef.current.setView([lat, lng], 18); } catch (err) {}
            }
        }
    }, []);

    const handleCardInstalacaoClick = useCallback((inst) => {
        setInstalacaoSelecionadaId(inst.id_instalacao);
        let targetLat = parseFloat(inst.latitude);
        let targetLng = parseFloat(inst.longitude);

        if (isNaN(targetLat) || isNaN(targetLng)) {
            if (inst.equipamentos && Array.isArray(inst.equipamentos)) {
                const eqComCoord = inst.equipamentos.find(e => !isNaN(parseFloat(e.latitude)) && !isNaN(parseFloat(e.longitude)));
                if (eqComCoord) {
                    targetLat = parseFloat(eqComCoord.latitude);
                    targetLng = parseFloat(eqComCoord.longitude);
                }
            }
        }

        if (!isNaN(targetLat) && !isNaN(targetLng)) {
            handleMarkerClick(targetLat, targetLng);
        }
    }, [handleMarkerClick]);

    const handleCenterChanged = () => {
        if (map) {
            const center = map.getCenter();
            const newPosition = { lat: center.lat(), lng: center.lng() };
            // Somente atualiza se houver uma mudança real na posição
            if (newPosition.lat !== mapPosition.lat || newPosition.lng !== mapPosition.lng) {
                setMapPosition(newPosition);
            }
        }
    };

    const handleZoomChanged = () => {
        if (map) {
            const newZoom = map.getZoom();
            // Somente atualiza se houver uma mudança real no nível de zoom
            if (newZoom !== zoom) {
                setZoom(newZoom);
            }
        }
    };


    const onMapLoad = (map) => {
        setMap(map);
        mapRef.current = map; // Armazena a instância do mapa
        setGoogleLoaded(true);
    };

    const handleClickInstalacao = (instalacao) => {
        console.log("clicou: " + instalacao.latitude + "," + instalacao.longitude);

        setZoom(18);
        setMapPosition({
            lat: parseFloat(instalacao.latitude),
            lng: parseFloat(instalacao.longitude)
        });
    };




    const options = {
        mapTypeId: 'satellite',
        streetViewControl: false, // Desativa o Street View
        fullscreenControl: false, // Desativa o controle de tela cheia
        mapTypeControl: false, // Desativa a opção de alterar o tipo de mapa
        zoomControl: true, // Ativa somente o controle de zoom
        maxZoom: 21,
        styles: [
            {
                featureType: "poi", // Oculta pontos de interesse
                elementType: "labels",
                stylers: [{ visibility: "off" }],
            },
            {
                featureType: "road", // Simplicidade nas rodovias
                elementType: "labels",
                stylers: [{ visibility: "off" }],
            },
            {
                featureType: "transit", // Remove transporte público
                stylers: [{ visibility: "off" }],
            },
            {
                featureType: "administrative.land_parcel", // Remove labels de terrenos
                stylers: [{ visibility: "off" }],
            },
            {
                featureType: "administrative.neighborhood", // Remove labels de bairros
                stylers: [{ visibility: "off" }],
            },
        ],
    };

    const [endereco, setEndereco] = useState();


    const marker = [
        {
            position: { lat: lat, lng: lng },
            title: "Unidade Base",
        },
    ];

    const [markers, setMarkers] = useState([]);


    const containerStyle = {
        width: '100%',
        height: '100%'
    };



    const [configuracoes, setConfiguracoes] = useState();
    const [loading, setLoading] = useState();
    const [loadingInstalacoes, setLoadingInstalacoes] = useState();

    async function listarInformacoes() {
        try {

            const token = Cookies.get('token');

            const headers = {
                'Authorization': 'Bearer ' + token
            }

            await api.get("/v1/protected/configuracoes", {
                headers: headers
            }).then(function (response) {
                setConfiguracoes(response.data);

                const lati = parseFloat(response.data.unidade_base.latitude);
                const lngi = parseFloat(response.data.unidade_base.longitude);

                setLat(lati);
                setLng(lngi);

                console.log("Lat: " + lati);
                console.log("Lng: " + lngi);
                setMapPosition({ lat: lati, lng: lngi });


                const logradouro = response.data.unidade_base.logradouro;
                const numero = response.data.unidade_base.numero;
                const bairro = response.data.unidade_base.bairro;
                const complemento = response.data.unidade_base.complemento;
                const cidade = response.data.unidade_base.cidade;
                const estado = response.data.unidade_base.estado;
                const cep = response.data.unidade_base.cep;

                const end = `${logradouro}, ${numero}, ${bairro}, ${cidade}, ${estado} - ${cep}`;
                setEndereco(end);
                console.log("Endereço: " + end);
                setLoading(false);


            });
        } catch (_err) {
            // avisar('Houve um problema com o login, verifique suas credenciais! ' + cpf + " " + senha );
            console.log("Erro ao listar informações: " + _err)

        }

    }



    const [googleLoaded, setGoogleLoaded] = useState(false);

    const handleLoadGoogle = () => {
        setGoogleLoaded(true);
    };




    function checkDimenssoes() {


        var largura = window.innerWidth
            || document.documentElement.clientWidth
            || document.body.clientWidth;

        setWidth(largura)

    }

    const [width, setWidth] = useState(0);



    window.addEventListener('resize', function (event) {
        checkDimenssoes();
    });


    useEffect(() => {


        listarInformacoes();
        // checkDimenssoes();




    }, []);











    const handleDefinirPerimetro = useCallback((id_inst) => {
        setDefiningPerimeter(true);
        setIdLocalDefinindoPerimetro(id_inst);
        setCurrentPerimeter(1);
        setPerimeterPoints([]);
    }, []);

    const handleSalvarPerimetro = useCallback(async (id_inst) => {
        try {
            const cadastro = {};
            perimeterPoints.slice(0, 8).forEach((point, index) => {
                if (point) {
                    cadastro[`latitude${index + 1}`] = point.lat.toString();
                    cadastro[`longitude${index + 1}`] = point.lng.toString();
                }
            });

            const headers = { 'Authorization': 'Bearer ' + Cookies.get("token") };
            const url = `/v1/protected/clientes/instalacoes/atualizarperimetro/${id_inst}`;
            const response = await api.put(url, cadastro, { headers });

            if (response.data) {
                setSnackbarMessage('Perímetro salvo com sucesso!');
                setSnackbarSeverity('success');
                setSnackbarOpen(true);
            }
        } catch (error) {
            setSnackbarMessage('Erro ao salvar perímetro.');
            setSnackbarSeverity('error');
            setSnackbarOpen(true);
            console.error("Erro ao salvar perímetro:", error);
        } finally {
            setDefiningPerimeter(false);
            setIdLocalDefinindoPerimetro(0);
            setPerimeterPoints([]);
        }
    }, [perimeterPoints]);

    const handleSendPgmCommand = useCallback(async (id_modulo_pgm, comando) => {
        try {
            const headers = { 'Authorization': 'Bearer ' + Cookies.get("token") };
            const url = `/v1/protected/modulopgm/tarefas/criarporareatecnica/` + Cookies.get("id_usuario") + "/" + id_modulo_pgm + "/" + comando;
            const response = await api.get(url, { headers });

            if (response.data) {
                setSnackbarMessage('Comando Enviado!');
                setSnackbarSeverity('success');
                setSnackbarOpen(true);
            }
        } catch (error) {
            setSnackbarMessage('Erro ao enviar comando');
            setSnackbarSeverity('error');
            setSnackbarOpen(true);
            console.error("Erro ao enviar o comando:", error);
        }
    }, []);

        const columnsInstalacoes = useMemo(
        () => [



            {
                accessorKey: 'nome_mapa', //normal accessorKey
                header: 'Local',
                size: 150,
                maxHeight: 60,
            },
            {
                accessorKey: 'identificador_integrador', //normal accessorKey
                header: 'ID Integrador',
                size: 100,
                maxHeight: 60,
            },

        ],
        [],
    );


    const polygonOptions = {
        strokeColor: 'blue',
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: 'blue',
        fillOpacity: 0.35,
        clickable: false,
        draggable: false,
        editable: false,
    };




    // lastUpdateTime removido para evitar re-renders globais desnecessarios


    const [isConnected, setIsConnected] = useState(false);


        // Conexão WebSocket em Tempo Real com Tópicos de Operação (Cache na RAM do Servidor - Padrão Operação)
    useEffect(() => {
        let isComponentMounted = true;
        let client = null;
        let waitingNextRequest = false;
        let nextRequestTimer = null;
        let reconnectTimer = null;

        const extrairInstalacoes = (dadosRecebidos) => {
            if (!dadosRecebidos) return [];
            if (Array.isArray(dadosRecebidos)) return dadosRecebidos;
            if (dadosRecebidos.instalacoes && Array.isArray(dadosRecebidos.instalacoes)) {
                return dadosRecebidos.instalacoes;
            }
            return [];
        };

        const connectToWebSocket = async () => {
            const token = Cookies.get('token');
            const idUsuario = Cookies.get('id_usuario');

            if (!token) return;

            let idCliente = null;

            // 1. Resolução do id_cliente com cache em sessionStorage (evita chamadas HTTP repetitivas)
            if (idUsuario) {
                const cachedCliente = sessionStorage.getItem(`id_cliente_${idUsuario}`);
                if (cachedCliente) {
                    idCliente = cachedCliente === 'ADMIN' ? null : cachedCliente;
                } else {
                    try {
                        const res = await api.get(`/v1/protected/user/retornardadosusuario/${idUsuario}`, {
                            headers: { Authorization: 'Bearer ' + token },
                            timeout: 3000
                        });
                        if (res.data && res.data.cliente && res.data.cliente.id_cliente) {
                            idCliente = res.data.cliente.id_cliente;
                            sessionStorage.setItem(`id_cliente_${idUsuario}`, String(idCliente));
                        } else {
                            sessionStorage.setItem(`id_cliente_${idUsuario}`, 'ADMIN');
                        }
                    } catch (err) {
                        console.warn("[MAPA] Fallback ao obter perfil de usuário:", err);
                    }
                }
            }

            if (!isComponentMounted) return;

            // 2. Conexão STOMP sobre WebSocket
            try {
                const socket = new WebSocket(`wss://gruporosinetos.com/api/monitoramentowebsocket?token=${token}`);
                client = Stomp.over(socket);
                client.debug = () => {}; // Silencia ruído do STOMP

                client.connect({}, () => {
                    if (!isComponentMounted) {
                        try { client.disconnect(); } catch (e) {}
                        return;
                    }
                    setIsConnected(true);

                    // Tópicos dedicados da Operação (com cache em RAM no backend)
                    const sendDestOperacao = idCliente ? `/app/operacao/requestData/cliente/${idCliente}` : "/app/operacao/requestData";
                    const topicDestOperacao = idCliente ? `/topic/operacao/dados/cliente/${idCliente}` : "/topic/operacao/dados";

                    const scheduleNext = (delayMs = 4000) => {
                        if (nextRequestTimer) clearTimeout(nextRequestTimer);
                        nextRequestTimer = setTimeout(() => {
                            waitingNextRequest = false;
                            sendRequest();
                        }, delayMs);
                    };

                    const sendRequest = () => {
                        if (client && client.connected && !waitingNextRequest) {
                            waitingNextRequest = true;
                            setIsProcessandoCiclo(true);
                            try {
                                client.send(sendDestOperacao, {}, JSON.stringify({}));
                            } catch (e) {
                                waitingNextRequest = false;
                                setIsProcessandoCiclo(false);
                                scheduleNext(5000);
                            }
                        }
                    };

                    const dadosSaoDiferentes = (novosDados, dadosAtuais) => {
                        if (!dadosAtuais || !novosDados) return true;
                        if (novosDados.length !== dadosAtuais.length) return true;

                        for (let i = 0; i < novosDados.length; i++) {
                            const novo = novosDados[i];
                            const atual = dadosAtuais[i];

                            if (!novo || !atual) return true;
                            if (novo.id_instalacao !== atual.id_instalacao ||
                                novo.nome_mapa !== atual.nome_mapa ||
                                novo.icone_mapa !== atual.icone_mapa ||
                                novo.latitude !== atual.latitude ||
                                novo.longitude !== atual.longitude) {
                                return true;
                            }

                            const novosEq = novo.equipamentos || [];
                            const atuaisEq = atual.equipamentos || [];
                            if (novosEq.length !== atuaisEq.length) return true;

                            for (let j = 0; j < novosEq.length; j++) {
                                const ne = novosEq[j];
                                const ae = atuaisEq[j];
                                if (!ne || !ae) return true;

                                if (ne.id_equipamento !== ae.id_equipamento ||
                                    ne.alarme !== ae.alarme ||
                                    ne.latitude !== ae.latitude ||
                                    ne.longitude !== ae.longitude) {
                                    return true;
                                }

                                if (ne.modulo_pgm && ae.modulo_pgm) {
                                    if (ne.modulo_pgm.armada !== ae.modulo_pgm.armada ||
                                        ne.modulo_pgm.status_central !== ae.modulo_pgm.status_central) {
                                        return true;
                                    }
                                    // Apenas considera diferente se o status online/offline (< 3 min) alterou
                                    const nowMs = Date.now();
                                    const onlineN = (nowMs - new Date(ne.modulo_pgm.data_hora_ultima_resposta)) / 60000 < 3;
                                    const onlineA = (nowMs - new Date(ae.modulo_pgm.data_hora_ultima_resposta)) / 60000 < 3;
                                    if (onlineN !== onlineA) {
                                        return true;
                                    }
                                    for (let k = 1; k <= 4; k++) {
                                        if (ne.modulo_pgm[`status_rele${k}`] !== ae.modulo_pgm[`status_rele${k}`]) {
                                            return true;
                                        }
                                    }
                                }
                            }
                        }
                        return false;
                    };

                    const handleIncomingData = (message) => {
                        try {
                            const raw = JSON.parse(message.body);
                            const lista = extrairInstalacoes(raw);

                            if (isComponentMounted && Array.isArray(lista)) {
                                setInstalacoes((prevInstalacoes) => {
                                    if (dadosSaoDiferentes(lista, prevInstalacoes)) {
                                        return lista;
                                    }
                                    return prevInstalacoes;
                                });
                                setLastSyncTime(new Date());
                                setLoadingInstalacoes(false);
                            }
                        } catch (err) {
                            console.error("[MAPA] Erro ao processar dados de Operação:", err);
                        } finally {
                            setIsProcessandoCiclo(false);
                            scheduleNext(4000);
                        }
                    };

                    client.subscribe(topicDestOperacao, handleIncomingData);
                    sendRequest();
                }, (error) => {
                    console.warn('[MAPA] WebSocket desconectado, tentando reconectar...', error);
                    setIsConnected(false);
                    if (isComponentMounted) {
                        if (reconnectTimer) clearTimeout(reconnectTimer);
                        reconnectTimer = setTimeout(connectToWebSocket, 5000);
                    }
                });
            } catch (err) {
                console.error('[MAPA] Falha ao iniciar WebSocket:', err);
                if (isComponentMounted) {
                    if (reconnectTimer) clearTimeout(reconnectTimer);
                    reconnectTimer = setTimeout(connectToWebSocket, 5000);
                }
            }
        };

        connectToWebSocket();

        return () => {
            isComponentMounted = false;
            if (nextRequestTimer) clearTimeout(nextRequestTimer);
            if (reconnectTimer) clearTimeout(reconnectTimer);
            if (client && client.connected) {
                try {
                    client.disconnect();
                } catch (e) {}
            }
        };
    }, []);


    const MapEvents = () => {
        useMapEvents({
            click: (e) => {
                if (definingPerimeter && currentPerimeter <= 8) {
                    const newPoint = {
                        lat: e.latlng.lat,
                        lng: e.latlng.lng,
                        label: `Perímetro ${currentPerimeter}`
                    };
                    setPerimeterPoints(prev => [...prev, newPoint]);
                    setCurrentPerimeter(prev => prev + 1);
                }
            },
            zoomend: (e) => {
                const currentZoom = Math.round(e.target.getZoom());
                setZoom(prev => prev !== currentZoom ? currentZoom : prev);
            }
        });
        return null;
    };

    return (
        <MuiThemeProvider theme={themeV5}>
            <CoreThemeProvider theme={themeV4}>
                <div style={{ backgroundColor: darkMode ? '#0b1120' : '#ffffff', minHeight: '100vh', color: darkMode ? '#f8fafc' : '#0f172a' }}>
                    <style>{`
                        .transparent-marker-icon { background: none; border: none; }
                        .transparent-tooltip { background: none; border: none; box-shadow: none; padding: 0; pointer-events: auto !important; }
                        .perimeter-label-icon { background: none; border: none; }
                        .leaflet-container { z-index: 1; background: ${darkMode ? '#0b1120' : '#f1f5f9'}; }
                        .leaflet-tooltip-bottom:before, .leaflet-tooltip-top:before, .leaflet-tooltip-left:before, .leaflet-tooltip-right:before { display: none !important; }
                        .leaflet-dark-mode-tiles {
                            filter: brightness(0.6) invert(1) contrast(3) hue-rotate(200deg) saturate(0.3) brightness(0.7) !important;
                        }
                    `}</style>
                    <NavegadorGestao
                        AreaTecnica={true}
                        Monitoramento={true}
                        MonitoramentoMapa={true}
                        corFundo={darkMode ? '#1e293b' : 'white'}
                        travado={true}
                        corTexto={darkMode ? '#ffffff' : 'black'}
                    />

            {loading ?
                <Skeleton animation={"wave"} style={{ backgroundColor: '#48D1CC' }}>
                </Skeleton>
                :
                <div className={classes.content}>
                    <React.Fragment >
                        <Grid
                            container
                            direction="row"
                            alignItems="center"
                            item xs={12}
                        >


                            <Grid
                                container
                                direction="row"
                                justifyContent="center"
                                align="center"
                                item xs={12}
                                style={{ position: 'absolute', top: 5, left: 0, width: '100%', height: '100%', zIndex: 0 }}
                            >
                                <MapContainer
                                    center={[mapPosition?.lat || -15.793889, mapPosition?.lng || -47.882778]}
                                    zoom={zoom}
                                    preferCanvas={true}
                                    wheelDebounceTime={40}
                                    style={{ width: '100%', height: '100%' }}
                                    whenReady={(mapInstance) => {
                                        setMap(mapInstance.target);
                                        mapRef.current = mapInstance.target;
                                    }}
                                >
                                    <TileLayer
                                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
                                        className={darkMode ? "leaflet-dark-mode-tiles" : ""}
                                        updateWhenIdle={true}
                                        updateWhenZooming={false}
                                        keepBuffer={8}
                                    />
                                    <MapEvents />

                                        {/* Marker vazio mantido por compatibilidade do layout original (linha 1302) */}
                                        <Marker position={[-15.793889, -47.882778]} icon={transparentDivIcon} />


                                        {!loadingInstalacoes && instalacoesEnriquecidas && instalacoesEnriquecidas.map((instalacao) => {
                                            // A instalacao so aparece no mapa se seu status estiver marcado para ver
                                            if (!statusFiltros[instalacao.status_geral]) {
                                                return null;
                                            }
                                            const latInstalacao = parseFloat(instalacao.latitude);
                                            const lngInstalacao = parseFloat(instalacao.longitude);
                                            const instalacaoValida = !isNaN(latInstalacao) && !isNaN(lngInstalacao);

                                            return (
                                                instalacaoValida && (
                                                    <React.Fragment key={instalacao.id_instalacao}>
                                                        <LocalComponent
                                                            id_instalacao={instalacao.id_instalacao}
                                                            lat={latInstalacao}
                                                            lng={lngInstalacao}
                                                            onClick={handleMarkerClick}
                                                            tipo_icone={instalacao.icone_mapa}
                                                            nome_mapa={instalacao.nome_mapa}
                                                            status={instalacao.status}
                                                            status_geral={instalacao.status_geral}
                                                            instalacao={instalacao}
                                                            darkMode={darkMode}
                                                            zoom={zoom}
                                                            definingPerimeter={definingPerimeter && idLocalDefinindoPerimetro === instalacao.id_instalacao}
                                                            onDefinirPerimetro={handleDefinirPerimetro}
                                                            onSalvarPerimetro={handleSalvarPerimetro}
                                                        />
                                                        {/* Modulos PGM e Modulo Sonoro so aparecem quando o zoom estiver bem proximo da localidade */}
                                                        {zoom >= 16 && instalacao.equipamentos && instalacao.equipamentos.map((equipamento) => {
                                                            const latEquipamento = parseFloat(equipamento.latitude);
                                                            const lngEquipamento = parseFloat(equipamento.longitude);
                                                            const equipamentoValido = !isNaN(latEquipamento) && !isNaN(lngEquipamento);

                                                            if (!equipamentoValido) return null;

                                                            if (equipamento.tipo_equipamento_area_tecnica === 0) {
                                                                return (
                                                                    <ModuloPGMComponent
                                                                        key={equipamento.id_equipamento}
                                                                        lat={latEquipamento}
                                                                        lng={lngEquipamento}
                                                                        tipo={equipamento.tipo_equipamento_area_tecnica}
                                                                        onClick={handleMarkerClick}
                                                                        status={instalacao.status}
                                                                        equipamento={equipamento}
                                                                        perimetro={instalacao.perimetro}
                                                                        id_instalacao={instalacao.id_instalacao}
                                                                        darkMode={darkMode}
                                                                        zoom={zoom}
                                                                        idLocalDefinindoPerimetro={idLocalDefinindoPerimetro}
                                                                        onSendPgmCommand={handleSendPgmCommand}
                                                                    />
                                                                );
                                                            }

                                                            if (equipamento.tipo_equipamento_area_tecnica === 30) {
                                                                return (
                                                                    <ModuloUnifierComponent
                                                                        key={equipamento.id_equipamento}
                                                                        lat={latEquipamento}
                                                                        lng={lngEquipamento}
                                                                        tipo={equipamento.tipo_equipamento_area_tecnica}
                                                                        onClick={handleMarkerClick}
                                                                        status={instalacao.status}
                                                                        equipamento={equipamento}
                                                                        id_instalacao={instalacao.id_instalacao}
                                                                        darkMode={darkMode}
                                                                        zoom={zoom}
                                                                        onSipCall={handleSipCall}
                                                                    />
                                                                );
                                                            }

                                                            return null;
                                                        })}
                                                    </React.Fragment>
                                                )
                                            );
                                        })}


                                        {/* Exibe os marcadores dos perímetros definidos */}
                                        {perimeterPoints.map((point, index) => (
                                            <Marker
                                                key={index}
                                                position={[point.lat, point.lng]}
                                                icon={new L.divIcon({ html: `<div style="background:${darkMode ? '#1e293b' : 'white'};color:${darkMode ? '#f8fafc' : 'black'};padding:2px 4px;border:1px solid ${darkMode ? '#475569' : 'black'};border-radius:2px;font-size:10px;font-weight:bold;">${point.label}</div>`, className: 'perimeter-label-icon' })}
                                            />
                                        ))}


                                        {perimeterPoints.length === 2 && (
                                            <Polyline
                                                positions={perimeterPoints.map(point => [point.lat, point.lng])}
                                                pathOptions={{ color: '#FF0000', opacity: 1.0, weight: 2 }}
                                            />
                                        )}

                                        {perimeterPoints.length >= 3 && perimeterPoints.length <= 8 && (
                                            <Polygon
                                                positions={perimeterPoints.map(point => [point.lat, point.lng])}
                                                pathOptions={{
                                                    fillColor: '#FF0000',
                                                    fillOpacity: 0.35,
                                                    color: '#FF0000',
                                                    opacity: 0.8,
                                                    weight: 2
                                                }}
                                            />
                                        )}






                                </MapContainer>
                            </Grid>

                        </Grid>


                    </React.Fragment>
                </div>

            }


            <Drawer
                variant="permanent"
                anchor="left"
                sx={{
                    top: '100px',
                    height: 'calc(100vh - 100px)',
                    flexShrink: 0,
                    '& .MuiDrawer-paper': {
                        position: 'fixed',
                        top: '100px',
                        width: '385px',
                        backgroundColor: darkMode ? '#0f172a' : '#ffffff',
                        borderRight: darkMode ? '1px solid rgba(255,255,255,0.08)' : '1px solid rgba(0,0,0,0.08)',
                        boxShadow: darkMode ? '4px 0 24px rgba(0, 0, 0, 0.4)' : '4px 0 24px rgba(0, 0, 0, 0.08)',
                        borderTopRightRadius: '16px',
                        overflowX: 'hidden',
                        transition: 'all 0.3s ease',
                        padding: '14px',
                        boxSizing: 'border-box'
                    },
                }}
            >
                {/* CARD DE SINCRONIZACAO COMPACTO E DISCRETO */}
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        px: 1,
                        py: 0.45,
                        mb: 0.8,
                        borderRadius: '6px',
                        background: darkMode ? 'rgba(30, 41, 59, 0.85)' : '#f1f5f9',
                        border: `1px solid ${darkMode ? 'rgba(255, 255, 255, 0.08)' : 'rgba(0, 0, 0, 0.08)'}`,
                    }}
                >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.6 }}>
                        <SyncIcon 
                            sx={{ 
                                fontSize: 14,
                                color: isProcessandoCiclo ? (darkMode ? '#38bdf8' : '#0284c7') : (lastSyncTime ? '#10b981' : (darkMode ? '#94a3b8' : '#64748b')),
                                animation: isProcessandoCiclo ? 'mapa-spin 1.2s linear infinite' : 'none',
                                '@keyframes mapa-spin': {
                                    '0%': { transform: 'rotate(0deg)' },
                                    '100%': { transform: 'rotate(360deg)' }
                                }
                            }} 
                        />
                        <Typography sx={{ fontSize: '0.62rem', fontWeight: 600, color: darkMode ? '#94a3b8' : '#64748b' }}>
                            Ult Recp: {lastSyncTime ? `${lastSyncTime.toLocaleTimeString('pt-BR')}` : (isProcessandoCiclo ? 'Buscando...' : 'Aguardando')}
                            {isProcessandoCiclo && <span style={{ color: darkMode ? '#38bdf8' : '#0284c7', marginLeft: '3px' }}>...</span>}
                        </Typography>
                    </Box>

                    {/* Total Discreto */}
                    <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.4, fontSize: '0.65rem', color: darkMode ? '#ffffff' : '#000000', fontWeight: 600 }}>
                        <FiberManualRecordIcon sx={{ fontSize: 7, color: isConnected ? '#10b981' : '#f59e0b' }} />
                        <span style={{ color: darkMode ? '#ffffff' : '#000000' }}>Total: <strong style={{ color: darkMode ? '#ffffff' : '#000000' }}>{snapshot.total_instalacoes}</strong></span>
                    </Box>
                </Box>
                <Divider sx={{ my: 0.8, borderColor: darkMode ? 'rgba(255,255,255,0.12)' : 'rgba(0,0,0,0.12)' }} />

                {showTable && (
                    <>
                        {/* CABECALHO COM FUNDO NA COR DO STATUS E TOGGLE */}
                        <Grid container spacing={1.2} sx={{ mb: 1.2 }}>
                            {/* Protegidas */}
                            <Grid item xs={6}>
                                <Paper
                                    elevation={0}
                                    onClick={() => toggleStatusFiltro("PROTEGIDA")}
                                    style={{
                                        backgroundColor: statusFiltros.PROTEGIDA ? (darkMode ? '#1e293b' : '#ffffff') : (darkMode ? 'rgba(30, 41, 59, 0.45)' : '#f8fafc'),
                                        border: '2px solid #10b981',
                                        borderRadius: '10px',
                                        padding: '12px 14px',
                                        cursor: 'pointer',
                                        opacity: statusFiltros.PROTEGIDA ? 1 : 0.45,
                                        transition: 'all 0.2s ease',
                                        boxShadow: darkMode ? '0 4px 12px rgba(0,0,0,0.3)' : '0 2px 6px rgba(0,0,0,0.06)'
                                    }}
                                    sx={{
                                        borderRadius: '10px',
                                        cursor: 'pointer',
                                        transition: 'all 0.2s ease',
                                        '&:hover': { opacity: 0.9, transform: 'translateY(-1px)' }
                                    }}
                                >
                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', gap: 1.2 }}>
                                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                            <Typography sx={{ fontSize: '0.72rem', fontWeight: 800, color: statusFiltros.PROTEGIDA ? (darkMode ? '#34d399' : '#059669') : '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.4px', mb: 0.5 }}>
                                                Protegidas
                                            </Typography>
                                            <Typography sx={{ fontSize: '1.35rem', fontWeight: 900, color: statusFiltros.PROTEGIDA ? (darkMode ? '#10b981' : '#047857') : '#94a3b8', lineHeight: 1, fontFamily: 'monospace' }}>
                                                {snapshot.total_protegidas}
                                            </Typography>
                                        </Box>
                                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.8 }}>
                                            <SecurityIcon sx={{ fontSize: 26, color: '#10b981', filter: statusFiltros.PROTEGIDA ? 'drop-shadow(0 1px 3px rgba(0,0,0,0.3))' : 'none' }} />
                                            {statusFiltros.PROTEGIDA ? (
                                                <CheckBoxIcon sx={{ fontSize: 16, color: '#10b981' }} />
                                            ) : (
                                                <CheckBoxOutlineBlankIcon sx={{ fontSize: 16, color: '#64748b' }} />
                                            )}
                                        </Box>
                                    </Box>
                                </Paper>
                            </Grid>

                            {/* Desarmadas */}
                            <Grid item xs={6}>
                                <Paper
                                    elevation={0}
                                    onClick={() => toggleStatusFiltro("DESARMADA")}
                                    style={{
                                        backgroundColor: statusFiltros.DESARMADA ? (darkMode ? '#1e293b' : '#ffffff') : (darkMode ? 'rgba(30, 41, 59, 0.45)' : '#f8fafc'),
                                        border: '2px solid #f59e0b',
                                        borderRadius: '10px',
                                        padding: '12px 14px',
                                        cursor: 'pointer',
                                        opacity: statusFiltros.DESARMADA ? 1 : 0.45,
                                        transition: 'all 0.2s ease',
                                        boxShadow: darkMode ? '0 4px 12px rgba(0,0,0,0.3)' : '0 2px 6px rgba(0,0,0,0.06)'
                                    }}
                                    sx={{
                                        borderRadius: '10px',
                                        cursor: 'pointer',
                                        transition: 'all 0.2s ease',
                                        '&:hover': { opacity: 0.9, transform: 'translateY(-1px)' }
                                    }}
                                >
                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', gap: 1.2 }}>
                                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                            <Typography sx={{ fontSize: '0.72rem', fontWeight: 800, color: statusFiltros.DESARMADA ? (darkMode ? '#fbbf24' : '#d97706') : '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.4px', mb: 0.5 }}>
                                                Desarmadas
                                            </Typography>
                                            <Typography sx={{ fontSize: '1.35rem', fontWeight: 900, color: statusFiltros.DESARMADA ? (darkMode ? '#f59e0b' : '#b45309') : '#94a3b8', lineHeight: 1, fontFamily: 'monospace' }}>
                                                {snapshot.total_desarmadas}
                                            </Typography>
                                        </Box>
                                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.8 }}>
                                            <SensorsIcon sx={{ fontSize: 26, color: '#f59e0b', filter: statusFiltros.DESARMADA ? 'drop-shadow(0 1px 3px rgba(0,0,0,0.3))' : 'none' }} />
                                            {statusFiltros.DESARMADA ? (
                                                <CheckBoxIcon sx={{ fontSize: 16, color: '#f59e0b' }} />
                                            ) : (
                                                <CheckBoxOutlineBlankIcon sx={{ fontSize: 16, color: '#64748b' }} />
                                            )}
                                        </Box>
                                    </Box>
                                </Paper>
                            </Grid>

                            {/* Desconectadas */}
                            <Grid item xs={6}>
                                <Paper
                                    elevation={0}
                                    onClick={() => toggleStatusFiltro("DESCONECTADA")}
                                    style={{
                                        backgroundColor: statusFiltros.DESCONECTADA ? (darkMode ? '#1e293b' : '#ffffff') : (darkMode ? 'rgba(30, 41, 59, 0.45)' : '#f8fafc'),
                                        border: '2px solid #64748b',
                                        borderRadius: '10px',
                                        padding: '12px 14px',
                                        cursor: 'pointer',
                                        opacity: statusFiltros.DESCONECTADA ? 1 : 0.45,
                                        transition: 'all 0.2s ease',
                                        boxShadow: darkMode ? '0 4px 12px rgba(0,0,0,0.3)' : '0 2px 6px rgba(0,0,0,0.06)'
                                    }}
                                    sx={{
                                        borderRadius: '10px',
                                        cursor: 'pointer',
                                        transition: 'all 0.2s ease',
                                        '&:hover': { opacity: 0.9, transform: 'translateY(-1px)' }
                                    }}
                                >
                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', gap: 1.2 }}>
                                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                            <Typography sx={{ fontSize: '0.72rem', fontWeight: 800, color: statusFiltros.DESCONECTADA ? (darkMode ? '#cbd5e1' : '#475569') : '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.4px', mb: 0.5 }}>
                                                Desconectadas
                                            </Typography>
                                            <Typography sx={{ fontSize: '1.35rem', fontWeight: 900, color: statusFiltros.DESCONECTADA ? (darkMode ? '#94a3b8' : '#334155') : '#94a3b8', lineHeight: 1, fontFamily: 'monospace' }}>
                                                {snapshot.total_desconectadas}
                                            </Typography>
                                        </Box>
                                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.8 }}>
                                            <SignalCellularConnectedNoInternet4BarIcon sx={{ fontSize: 26, color: darkMode ? '#94a3b8' : '#64748b' }} />
                                            {statusFiltros.DESCONECTADA ? (
                                                <CheckBoxIcon sx={{ fontSize: 16, color: darkMode ? '#94a3b8' : '#64748b' }} />
                                            ) : (
                                                <CheckBoxOutlineBlankIcon sx={{ fontSize: 16, color: '#64748b' }} />
                                            )}
                                        </Box>
                                    </Box>
                                </Paper>
                            </Grid>

                            {/* Em Alarme */}
                            <Grid item xs={6}>
                                <Paper
                                    elevation={0}
                                    onClick={() => toggleStatusFiltro("ALARME")}
                                    style={{
                                        backgroundColor: statusFiltros.ALARME ? (darkMode ? '#1e293b' : '#ffffff') : (darkMode ? 'rgba(30, 41, 59, 0.45)' : '#f8fafc'),
                                        border: '2px solid #ef4444',
                                        borderRadius: '10px',
                                        padding: '12px 14px',
                                        cursor: 'pointer',
                                        opacity: statusFiltros.ALARME ? 1 : 0.45,
                                        transition: 'all 0.2s ease',
                                        boxShadow: darkMode ? '0 4px 12px rgba(0,0,0,0.3)' : '0 2px 6px rgba(0,0,0,0.06)'
                                    }}
                                    sx={{
                                        borderRadius: '10px',
                                        cursor: 'pointer',
                                        transition: 'all 0.2s ease',
                                        '&:hover': { opacity: 0.9, transform: 'translateY(-1px)' }
                                    }}
                                >
                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', gap: 1.2 }}>
                                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                            <Typography sx={{ fontSize: '0.72rem', fontWeight: 800, color: statusFiltros.ALARME ? (darkMode ? '#f87171' : '#dc2626') : '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.4px', mb: 0.5 }}>
                                                Em Alarme
                                            </Typography>
                                            <Typography sx={{ fontSize: '1.35rem', fontWeight: 900, color: statusFiltros.ALARME ? (darkMode ? '#ef4444' : '#b91c1c') : '#94a3b8', lineHeight: 1, fontFamily: 'monospace' }}>
                                                {snapshot.total_em_alarme}
                                            </Typography>
                                        </Box>
                                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.8 }}>
                                            <NotificationsActiveIcon sx={{ fontSize: 26, color: '#ef4444', filter: statusFiltros.ALARME ? 'drop-shadow(0 1px 3px rgba(0,0,0,0.3))' : 'none' }} />
                                            {statusFiltros.ALARME ? (
                                                <CheckBoxIcon sx={{ fontSize: 16, color: '#ef4444' }} />
                                            ) : (
                                                <CheckBoxOutlineBlankIcon sx={{ fontSize: 16, color: '#64748b' }} />
                                            )}
                                        </Box>
                                    </Box>
                                </Paper>
                            </Grid>
                        </Grid>
                        <Divider sx={{ my: 1, borderColor: darkMode ? 'rgba(255,255,255,0.12)' : 'rgba(0,0,0,0.12)' }} />
                        {/* 4. BARRA DE PESQUISA (Igual a Operacao) */}
                        <TextField
                            fullWidth
                            size="small"
                            placeholder="Pesquisar por nome, PGM, ramal, cidade..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            variant="outlined"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon sx={{ color: darkMode ? '#94a3b8' : '#64748b', fontSize: 18 }} />
                                    </InputAdornment>
                                ),
                                endAdornment: searchTerm ? (
                                    <InputAdornment position="end">
                                        <IconButton size="small" onClick={() => setSearchTerm("")}>
                                            <ClearIcon fontSize="small" />
                                        </IconButton>
                                    </InputAdornment>
                                ) : null,
                                sx: {
                                    background: darkMode ? '#1e293b' : '#ffffff',
                                    borderRadius: '8px',
                                    fontSize: '0.78rem',
                                    fontWeight: 500,
                                    mb: 1.2,
                                    color: darkMode ? '#f8fafc' : '#0f172a',
                                    '& fieldset': {
                                        borderColor: darkMode ? 'rgba(255,255,255,0.12)' : 'rgba(0,0,0,0.12)'
                                    }
                                }
                            }}
                        />

                        <Divider sx={{ my: 0.8, borderColor: darkMode ? 'rgba(255,255,255,0.12)' : 'rgba(0,0,0,0.12)' }} />
                        {/* 5. LISTA DE CARDS DE INSTALACOES */}
                        <Box
                            sx={{
                                flex: 1,
                                overflowY: 'auto',
                                maxHeight: 'calc(100vh - 355px)',
                                pr: 0.5,
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 1,
                                '&::-webkit-scrollbar': {
                                    width: '5px'
                                },
                                '&::-webkit-scrollbar-thumb': {
                                    backgroundColor: darkMode ? '#334155' : '#cbd5e1',
                                    borderRadius: '4px'
                                }
                            }}
                        >
                            {instalacoesFiltradas.length === 0 ? (
                                <Paper
                                    elevation={0}
                                    sx={{
                                        p: 2,
                                        textAlign: 'center',
                                        background: darkMode ? '#1e293b' : '#f8fafc',
                                        border: `1px solid ${darkMode ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.06)'}`,
                                        borderRadius: '8px'
                                    }}
                                >
                                    <Typography sx={{ fontSize: '0.78rem', color: darkMode ? '#94a3b8' : '#64748b' }}>
                                        {snapshot.total_instalacoes === 0 
                                            ? (isProcessandoCiclo ? 'Buscando instalações no servidor...' : 'Nenhuma instalação conectada.')
                                            : 'Nenhuma instalação corresponde aos filtros e busca.'}
                                    </Typography>
                                </Paper>
                            ) : (
                                instalacoesFiltradas.map((inst) => {
                                    const isSelected = instalacaoSelecionadaId === inst.id_instalacao;
                                    const statusColor = inst.status_geral === "PROTEGIDA" ? "#10b981" :
                                                        inst.status_geral === "DESARMADA" ? "#f59e0b" :
                                                        inst.status_geral === "DESCONECTADA" ? "#64748b" : "#ef4444";

                                    return (
                                        <React.Fragment key={inst.id_instalacao}>
                                        <Paper
                                            elevation={0}
                                            onClick={() => handleCardInstalacaoClick(inst)}
                                            style={{
                                                backgroundColor: isSelected 
                                                    ? (darkMode ? '#1e3a5f' : '#e0f2fe') 
                                                    : (darkMode ? '#1e293b' : '#ffffff'),
                                                color: darkMode ? '#f8fafc' : '#0f172a',
                                                border: `2px solid ${statusColor}`,
                                                borderRadius: '10px',
                                                padding: '9px 12px',
                                                cursor: 'pointer',
                                                transition: 'all 0.2s ease',
                                                boxShadow: isSelected 
                                                    ? `0 0 0 2px ${statusColor}, 0 6px 16px rgba(0,0,0,0.35)` 
                                                    : (darkMode ? '0 3px 10px rgba(0,0,0,0.35)' : '0 2px 6px rgba(0,0,0,0.06)')
                                            }}
                                            sx={{
                                                borderRadius: '10px',
                                                cursor: 'pointer',
                                                transition: 'all 0.2s ease',
                                                '&:hover': {
                                                    boxShadow: `0 6px 16px ${statusColor}50`,
                                                    transform: 'translateY(-1px)',
                                                    backgroundColor: darkMode ? '#24334a' : '#f8fafc'
                                                }
                                            }}
                                        >
                                            {/* Linha 1: Status Badge + Codigo dos Modulos + Ultima Resposta */}
                                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 0.8, mb: 0.6, flexWrap: 'wrap' }}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.6, flexWrap: 'wrap' }}>
                                                    <Chip
                                                        label={inst.status_geral}
                                                        size="small"
                                                        sx={{
                                                            fontSize: '0.65rem',
                                                            fontWeight: 800,
                                                            height: '20px',
                                                            backgroundColor: `${statusColor}22`,
                                                            color: statusColor,
                                                            border: `1.5px solid ${statusColor}`
                                                        }}
                                                    />
                                                    {inst.codigo_pgm && (
                                                        <Chip
                                                            label={`PGM: ${inst.codigo_pgm}`}
                                                            size="small"
                                                            sx={{
                                                                fontSize: '0.65rem',
                                                                fontWeight: 700,
                                                                height: '20px',
                                                                backgroundColor: darkMode ? '#0f172a' : '#f1f5f9',
                                                                color: darkMode ? '#e2e8f0' : '#1e293b',
                                                                border: `1px solid ${darkMode ? 'rgba(255,255,255,0.15)' : 'rgba(0,0,0,0.12)'}`
                                                            }}
                                                        />
                                                    )}
                                                    {inst.codigo_sonoro && (
                                                        <Chip
                                                            icon={<VolumeUpIcon style={{ fontSize: 12, color: '#38bdf8' }} />}
                                                            label={`Sonoro: ${inst.codigo_sonoro}`}
                                                            size="small"
                                                            sx={{
                                                                fontSize: '0.65rem',
                                                                fontWeight: 700,
                                                                height: '20px',
                                                                backgroundColor: darkMode ? '#0c2238' : '#e0f2fe',
                                                                color: darkMode ? '#7dd3fc' : '#0369a1',
                                                                border: `1px solid ${darkMode ? 'rgba(56, 189, 248, 0.3)' : 'rgba(3, 105, 161, 0.25)'}`
                                                            }}
                                                        />
                                                    )}
                                                </Box>

                                                {/* Ultima resposta com letra menor para caber na mesma linha */}
                                                <Typography
                                                    sx={{
                                                        fontSize: '0.62rem',
                                                        color: darkMode ? '#94a3b8' : '#64748b',
                                                        lineHeight: 1.2,
                                                        whiteSpace: 'nowrap',
                                                        ml: 'auto'
                                                    }}
                                                >
                                                    Últ. Resp: <span style={{ fontWeight: 600, color: darkMode ? '#cbd5e1' : '#334155' }}>{formatarDataHora(inst.data_hora_pgm)}</span>
                                                    {inst.tem_modulo_sonoro && (
                                                        <span style={{ marginLeft: 6 }}>
                                                            | Sonoro: <span style={{ fontWeight: 600, color: darkMode ? '#cbd5e1' : '#334155' }}>{formatarDataHora(inst.data_hora_sonoro)}</span>
                                                        </span>
                                                    )}
                                                </Typography>
                                            </Box>

                                            {/* Linha 2: Nome da Instalacao + Botoes de Acao e Chamada */}
                                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1, mb: 0.5 }}>
                                                <Typography
                                                    sx={{
                                                        fontWeight: 800,
                                                        fontSize: '0.92rem',
                                                        color: darkMode ? '#ffffff' : '#0f172a',
                                                        lineHeight: 1.25,
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                        whiteSpace: 'nowrap',
                                                        flex: 1
                                                    }}
                                                    title={inst.nome_mapa}
                                                >
                                                    {inst.nome_mapa || `Instalação #${inst.id_instalacao}`}
                                                </Typography>

                                                {/* Botoes de Acao + Botao de Chamada */}
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.6, flexShrink: 0 }}>
                                                    {/* Botao de Chamada para Ramal */}
                                                    {inst.ramal && (
                                                        <Tooltip title={`Ligar para ramal ${inst.ramal}`}>
                                                            <Button
                                                                size="small"
                                                                startIcon={<CallIcon sx={{ fontSize: 13, color: '#10b981' }} />}
                                                                onClick={(e) => handleSipCall(inst.ramal, e)}
                                                                sx={{
                                                                    py: 0.15,
                                                                    px: 0.7,
                                                                    fontSize: '0.68rem',
                                                                    fontWeight: 800,
                                                                    fontFamily: 'monospace',
                                                                    textTransform: 'none',
                                                                    backgroundColor: 'rgba(16, 185, 129, 0.15)',
                                                                    color: '#10b981',
                                                                    border: '1px solid #10b981',
                                                                    borderRadius: '5px',
                                                                    minWidth: 'auto',
                                                                    height: '24px',
                                                                    '&:hover': {
                                                                        backgroundColor: '#10b981',
                                                                        color: '#ffffff'
                                                                    }
                                                                }}
                                                            >
                                                                {inst.ramal}
                                                            </Button>
                                                        </Tooltip>
                                                    )}

                                                    {/* 1) Botao Painel da Instalacao */}
                                                    <Tooltip title="Abrir painel da instalação">
                                                        <IconButton
                                                            size="small"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                setInstalacaoPainelDetalhes(inst);
                                                            }}
                                                            sx={{
                                                                width: 24,
                                                                height: 24,
                                                                color: darkMode ? '#38bdf8' : '#0284c7',
                                                                backgroundColor: darkMode ? 'rgba(56, 189, 248, 0.12)' : 'rgba(2, 132, 199, 0.08)',
                                                                border: `1px solid ${darkMode ? 'rgba(56, 189, 248, 0.25)' : 'rgba(2, 132, 199, 0.2)'}`,
                                                                borderRadius: '5px',
                                                                p: 0,
                                                                '&:hover': {
                                                                    backgroundColor: darkMode ? 'rgba(56, 189, 248, 0.25)' : 'rgba(2, 132, 199, 0.18)',
                                                                }
                                                            }}
                                                        >
                                                            <DashboardIcon sx={{ fontSize: 14 }} />
                                                        </IconButton>
                                                    </Tooltip>

                                                    {/* 2) Botao Ver no mapa */}
                                                    <Tooltip title="Ver no mapa">
                                                        <IconButton
                                                            size="small"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleCardInstalacaoClick(inst);
                                                            }}
                                                            sx={{
                                                                width: 24,
                                                                height: 24,
                                                                color: darkMode ? '#94a3b8' : '#64748b',
                                                                backgroundColor: darkMode ? 'rgba(255, 255, 255, 0.04)' : 'rgba(0, 0, 0, 0.04)',
                                                                border: `1px solid ${darkMode ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)'}`,
                                                                borderRadius: '5px',
                                                                p: 0,
                                                                '&:hover': {
                                                                    color: '#0284c7',
                                                                    borderColor: '#0284c7',
                                                                    backgroundColor: 'rgba(2, 132, 199, 0.12)',
                                                                }
                                                            }}
                                                        >
                                                            <LocationOnIcon sx={{ fontSize: 14 }} />
                                                        </IconButton>
                                                    </Tooltip>

                                                    {/* 3) Botao Gerenciar */}
                                                    <Tooltip title="Gerenciar instalação">
                                                        <IconButton
                                                            size="small"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                window.open(`/gestao/administracao/clientes/gerenciarcliente/instalacao/gerenciarinstalacao/${inst.id_instalacao}/0`, '_blank');
                                                            }}
                                                            sx={{
                                                                width: 24,
                                                                height: 24,
                                                                color: darkMode ? '#f59e0b' : '#d97706',
                                                                backgroundColor: darkMode ? 'rgba(245, 158, 11, 0.12)' : 'rgba(217, 119, 6, 0.08)',
                                                                border: `1px solid ${darkMode ? 'rgba(245, 158, 11, 0.25)' : 'rgba(217, 119, 6, 0.2)'}`,
                                                                borderRadius: '5px',
                                                                p: 0,
                                                                '&:hover': {
                                                                    backgroundColor: darkMode ? 'rgba(245, 158, 11, 0.25)' : 'rgba(217, 119, 6, 0.18)',
                                                                }
                                                            }}
                                                        >
                                                            <ManageAccountsIcon sx={{ fontSize: 14 }} />
                                                        </IconButton>
                                                    </Tooltip>
                                                </Box>
                                            </Box>

                                            {/* Linha 3: Localizacao */}
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.6 }}>
                                                <LocationOnIcon sx={{ fontSize: 15, color: statusColor, flexShrink: 0 }} />
                                                <Typography
                                                    sx={{
                                                        fontSize: '0.73rem',
                                                        color: darkMode ? '#94a3b8' : '#64748b',
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                        whiteSpace: 'nowrap',
                                                        fontWeight: 500
                                                    }}
                                                >
                                                    {inst.bairro ? `${inst.bairro}${inst.cidade ? ` - ${inst.cidade}` : ''}` : (inst.identificador_integrador ? `${inst.identificador_integrador}` : 'Localização não informada')}
                                                </Typography>
                                            </Box>
                                        </Paper>
                                        <Divider sx={{ my: 0.8, borderColor: darkMode ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.06)' }} />
                                    </React.Fragment>
                                    );
                                })
                            )}
                        </Box>
                    </>
                )}
            </Drawer>

            {/* Painel da Instalacao (o mesmo painel que se abre na pagina de Operacao) */}
            {instalacaoPainelDetalhes && (
                <PainelInstalacaoDetalhes
                    instalacaoSelecionada={instalacaoPainelDetalhes}
                    setInstalacaoSelecionada={setInstalacaoPainelDetalhes}
                    larguraOriginal={window.innerWidth}
                    limiar={768}
                    darkMode={darkMode}
                    activeCallRamal={null}
                    handleSipHangup={handleSipHangup}
                    handleSipCall={handleSipCall}
                    returnDescricaoEndereco={returnDescricaoEndereco}
                    handleOpenGraficoDisponibilidade={() => setOpenGraficoDisponibilidade(true)}
                    useNativeCall={false}
                    toggleSipMode={() => {}}
                    sipStatus="ready"
                />
            )}

            {/* Modal do Grafico de Disponibilidade */}
            {openGraficoDisponibilidade && instalacaoPainelDetalhes && (
                <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', zIndex: 99999 }}>
                    <GraficoDisponibilidade
                        idInstalacao={instalacaoPainelDetalhes.id_instalacao}
                        instalacao={instalacaoPainelDetalhes}
                        onClose={() => setOpenGraficoDisponibilidade(false)}
                    />
                </div>
            )}

            <Snackbar
                open={snackbarOpen}
                autoHideDuration={4000}
                onClose={handleCloseSnackbar}
                message={snackbarMessage}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                ContentProps={{
                    'aria-describedby': 'message-id',
                    style: {
                        backgroundColor: snackbarSeverity === 'success' 
                            ? (darkMode ? '#065f46' : '#4caf50') 
                            : (darkMode ? '#991b1b' : '#f44336'),
                        marginTop: '60px', // Ajuste a altura conforme necessário
                        fontSize: '16px',
                        fontWeight: 'bold',
                        border: darkMode ? '1px solid rgba(255,255,255,0.1)' : '1px solid black',
                        color: '#ffffff',
                        borderRadius: '6px',
                        padding: '10px 16px',
                        zIndex: 1500,
                        boxShadow: darkMode ? '0 4px 16px rgba(0,0,0,0.5)' : '0 2px 6px rgba(0,0,0,0.3)',
                    }
                }}
            />

                </div>
            </CoreThemeProvider>
        </MuiThemeProvider>
    );
}





